import { useAuth0Mutation } from "@workspace/casino_core/mutations/Auth0Mutation.client";
import filterAuthResponse from "../helpers/utils";

const useHandleAuth0Authenticate = () => {
  const [completeAuth0Registration, { loading }] = useAuth0Mutation();
  const handleAuth0Authenticate = async (
    variables: AuthVariables,
    accessToken: string,
  ) => {
    const response = await completeAuth0Registration({
      ...variables,
      accessToken: accessToken,
    });
    return filterAuthResponse(response?.data?.userManagementAuth0Authenticate);
  };
  return {
    handleAuth0Authenticate,
    loading,
  };
};

export default useHandleAuth0Authenticate;
